import { SelectedFilterType } from '../types/filter.type'
import { AssetType } from '../types/bucketTypes'
import { MAKE, MANUFACTURER, MODEL } from '../constants/filter.constants'

export const onFilterAssets = (
    filter: SelectedFilterType[],
    assets?: AssetType[]
) => {
    if (assets == undefined) return []
    //list all filters with checked value
    const { makeFilters, manufacturerFilters, modelFilters } =
        getCheckedFilters(filter)

    return assets.filter((asset: any) => {
        const {
            bucket: { make, model, manufacturer },
        } = asset

        const isMakeIncluded = isEmpty(makeFilters)
            ? true
            : makeFilters.includes(make)
        const isModelIncluded = isEmpty(modelFilters)
            ? true
            : modelFilters.includes(model)
        const isManufacturerIncluded = isEmpty(manufacturerFilters)
            ? true
            : manufacturerFilters.includes(manufacturer)

        return isMakeIncluded && isModelIncluded && isManufacturerIncluded
    })
}

const getCheckedFilters = (filters: SelectedFilterType[]) => {
    //filter to only return object with true values, map to only return checked string instead of whole object data
    let makeFilters: string[] = []
    let modelFilters: string[] = []
    let manufacturerFilters: string[] = []

    filters.forEach((filter: SelectedFilterType) => {
        if (filter.category == MAKE) makeFilters.push(filter.title)
        if (filter.category == MODEL) modelFilters.push(filter.title)
        if (filter.category == MANUFACTURER)
            manufacturerFilters.push(filter.title)
    })
    return {
        makeFilters,
        modelFilters,
        manufacturerFilters,
    }
}

const isEmpty = (array: Array<unknown>) =>
    array.length == 0 || array == undefined
